import {
  Link,
  MESSAGE_BOX_VARIANT_DANGER,
  MessageBox,
} from 'mailup-web-components'
import React, { type FC, type PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'

interface ErrorFeedbackProps {
  onReload?: () => void | Promise<void>
  className?: string
}

const ErrorFeedback: FC<PropsWithChildren<ErrorFeedbackProps>> = ({
  children,
  onReload,
  className,
}) => {
  const intl = useIntl()

  if (children === null || children === undefined) {
    return null
  }

  return (
    <MessageBox className={className} variant={MESSAGE_BOX_VARIANT_DANGER}>
      <span>{children}</span>{' '}
      {typeof onReload === 'function' && (
        <Link onClick={onReload}>
          {intl.formatMessage({ id: 'Load.Common.RealoadPage' })}
        </Link>
      )}
    </MessageBox>
  )
}

export default ErrorFeedback
